<template>
  <div class="app-container" style="width:850px;">
    <el-form :model="data" :rules="rules" ref="form" label-width="110px">
      微信平台接入信息
      <el-row class="row-border">
        <el-col :span="24">
          <el-form-item label="商户号" prop="WechatMerchantId">
            <el-input v-model="data.WechatMerchantId" placeholder="请输入商户号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="支付密钥" prop="WechatPayKey">
            <el-input v-model="data.WechatPayKey" placeholder="请输入支付密钥"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="商户证书" prop="WechatMerchantCer">
            <el-col :span="24">
              <el-input v-model="data.WechatMerchantCer" placeholder="请选择商户证书" />
              <el-upload 
                ref="upload"
                style="position: absolute;top: 0;right: 0;"
                :action="host + '/api/Common/UploadFile'"
                :on-success="onSuccess"
                accept=".pdf,.txt,.docx,.xlsx," 
                :headers="headers"
                :show-file-list="false"
                :before-upload="beforeFileUpload">
                  <el-button icon="el-icon-upload2" type="primary" title="点击选择文件"></el-button>
              </el-upload>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="商户Key证书" prop="WechatMerchantKeycer">
            <el-col :span="24">
              <el-input v-model="data.WechatMerchantKeycer" placeholder="请选择Key证书" />
              <el-upload 
                ref="upload"
                style="position: absolute;top: 0;right: 0;"
                :action="host + '/api/Common/UploadFile'"
                :on-success="onSuccess1"
                accept=".pdf,.txt,.docx,.xlsx," 
                :headers="headers"
                :show-file-list="false"
                :before-upload="beforeFileUpload">
                  <el-button icon="el-icon-upload2" type="primary" title="点击选择文件"></el-button>
              </el-upload>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      支付宝平台接入信息
      <el-row class="row-border">
        <el-col :span="24">
          <el-form-item label="AppID" prop="AlipayAppId">
            <el-input v-model="data.AlipayAppId" placeholder="请输入AppID"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="公钥证书" prop="AlipayPublicCer">
            <el-col :span="24">
              <el-input v-model="data.AlipayPublicCer" placeholder="请选择Key证书" />
              <el-upload 
                ref="upload"
                style="position: absolute;top: 0;right: 0;"
                :action="host + '/api/Common/UploadFile'"
                :on-success="onSuccess2"
                accept=".pdf,.txt,.docx,.xlsx," 
                :headers="headers"
                :show-file-list="false"
                :before-upload="beforeFileUpload">
                  <el-button icon="el-icon-upload2" type="primary" title="点击选择文件"></el-button>
              </el-upload>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="应用公钥证书" prop="AlipayAppCer">
            <el-col :span="24">
              <el-input v-model="data.AlipayAppCer" placeholder="请选择Key证书" />
              <el-upload 
                ref="upload"
                style="position: absolute;top: 0;right: 0;"
                :action="host + '/api/Common/UploadFile'"
                :on-success="onSuccess3"
                accept=".pdf,.txt,.docx,.xlsx," 
                :headers="headers"
                :show-file-list="false"
                :before-upload="beforeFileUpload">
                  <el-button icon="el-icon-upload2" type="primary" title="点击选择文件"></el-button>
              </el-upload>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="支付宝根证书" prop="AlipayRootCer">
            <el-col :span="24">
              <el-input v-model="data.AlipayRootCer" placeholder="支付宝根证书" />
              <el-upload 
                ref="upload"
                style="position: absolute;top: 0;right: 0;"
                :action="host + '/api/Common/UploadFile'"
                :on-success="onSuccess4"
                accept=".pdf,.txt,.docx,.xlsx," 
                :headers="headers"
                :show-file-list="false"
                :before-upload="beforeFileUpload">
                  <el-button icon="el-icon-upload2" type="primary" title="点击选择文件"></el-button>
              </el-upload>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Private_key" prop="AlipayPrivateKey">
            <el-input v-model="data.AlipayPrivateKey" placeholder="请输入Private_key"></el-input>
          </el-form-item>
        </el-col>       
      </el-row>
      
      <el-button v-if="canEdit" type="primary" @click="onSubmit" size="small" style="margin: 10px 10px 0 0;float:right;">保 存</el-button>
    </el-form>
  </div>
  
</template>
<script>
import singlePicUpload from "@/components/common/photo/singleUpload";

export default {
  name: "pay",
  components: {
    singlePicUpload,
  },
  computed: {
    host() {
      return window.location.origin;
    }
  },
  data() {
    return {
      data: {
        RecordId: 0,
        WechatMerchantId: "",
        WechatPayKey: "",
        WechatMerchantCer: "",
        WechatMerchantKeycer: "",
        AlipayAppId: "",
        AlipayPublicCer: "",
        AlipayAppCer:"",
        AlipayRootCer: "",
        AlipayPrivateKey:"",
      },
      headers: { Authorization: "" },
      dialogVisible: false,
      isLoading: false,
      isMB: this.$store.state.isMB,
      api: require("@/api/access/pay").default,
      canEdit: false,
      rules: {
        WechatMerchantId: [{ required: true, message: "微信商户号不能为空" }],
        WechatPayKey: [{ required: true, message: "微信支付密钥不能为空" }],
        WechatMerchantCer: [{ required: true, message: "微信商户证书不能为空" }],
        WechatMerchantKeycer: [{ required: true, message: "微信商户key证书不能为空" }],
        AlipayAppId: [{ required: true, message: "支付宝AppId不能为空" }],
        AlipayPublicCer: [{ required: true, message: "支付宝公钥证书不能为空" }],
        AlipayAppCer: [{ required: true, message: "应用公钥证书不能为空" }],
        AlipayRootCer: [{ required: true, message: "支付宝根证书不能为空" }],
        AlipayPrivateKey: [{ required: true, message: "支付宝private_key不能为空" }],
      },
      uploadUrl: "/api/Common/UploadPicture",
    };
  },
  mounted() {
    this.canEdit = this.$permission.canEdit();
    this.api.info(1).then((res) => {
      if (res.Code == 0) {
        this.data = res.Data;
      } else {
        this.$message.error(res.Msg);
      }
    });
  },
  methods: {
    toUpload() {

     },
     beforeFileUpload(file) {
      var limit = this.$store.state.user.attSize;
      this.headers.Authorization = "Bearer " + this.$commonJs.getCookie("token");
      const result = file.size/1024/1024 <= limit || limit == 0;
      if(!result) {
        this.$message.error("附件大小不能超过" + limit + "M");
      }
      return result;
    },
    onSuccess(res,file) {
      if(res.Code==0) {
        this.data.WechatMerchantCer = res.Data;
        this.$message.success(res.Msg);
      } else {
        this.$message.error(res.Msg);
      }
    },
    onSuccess1(res,file) {
      if(res.Code==0) {
        this.data.WechatMerchantKeycer = res.Data;
        this.$message.success(res.Msg);
      } else {
        this.$message.error(res.Msg);
      }
    },
    onSuccess2(res,file) {
      if(res.Code==0) {
        this.data.AlipayPublicCer = res.Data;
        this.$message.success(res.Msg);
      } else {
        this.$message.error(res.Msg);
      }
    },
    onSuccess3(res,file) {
      if(res.Code==0) {
        this.data.AlipayAppCer = res.Data;
        this.$message.success(res.Msg);
      } else {
        this.$message.error(res.Msg);
      }
    },
    onSuccess4(res,file) {
      if(res.Code==0) {
        this.data.AlipayRootCer = res.Data;
        this.$message.success(res.Msg);
      } else {
        this.$message.error(res.Msg);
      }
    },
    checkInt(name) {
      if(!(this.data[name] >= 0)) {
        this.data[name] = 0;
      } else if(this.data[name] %1 != 0) {
        this.data[name] = Math.floor(this.data[name]);
      }
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isLoading = true;
          this.api.save(this.data).then((res) => {
            this.isLoading = false;
            if (res.Code == 0) {
              this.$message({
                message: res.Msg,
                type: "success",
                duration: 3000,
              });
             
            } else {
              this.$message.error(res.Msg);
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
